import React, { PureComponent, createRef } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { withUrlContext } from 'hoc/url';
import { withData } from './data';
import { EventPDFUI } from './ui';

export class EventPDF extends PureComponent {
    static displayName = 'EventPDFContainer';

    static propTypes = {
        pathname: PropTypes.string,
        eventId: PropTypes.string,
        hasOtherAttachment: PropTypes.bool,
        company: PropTypes.objectOf(PropTypes.any),
        page: PropTypes.string,
        pdfUrl: PropTypes.string,
        setToolbarTitle: PropTypes.func,
        styles: PropTypes.objectOf(PropTypes.any),
        title: PropTypes.string,
        type: PropTypes.string,
        loading: PropTypes.bool,
        eventTitle: PropTypes.string,
        dateString: PropTypes.string
    };

    static defaultProps = {
        page: undefined,
        pathname: undefined,
        eventId: undefined,
        hasOtherAttachment: false,
        loading: false,
        company: undefined,
        pdfUrl: '',
        setToolbarTitle: null,
        styles: undefined,
        title: 'Loading...',
        type: undefined,
        eventTitle: '',
        dateString: ''
    };

    constructor(props) {
        super(props);

        this.containerRef = createRef();
        this.documentTitle = document.title;
    }

    componentDidUpdate({ title: prevTitle }) {
        const { title } = this.props;

        if (prevTitle !== title) {
            document.title = `Aiera | PDF | ${title}`;
        }
    }

    componentWillUnmount() {
        document.title = this.documentTitle; // reset page title
    }

    render() {
        const {
            pathname,
            hasOtherAttachment,
            eventTitle,
            eventId,
            dateString,
            company,
            loading,
            page,
            pdfUrl,
            setToolbarTitle,
            styles,
            title,
            type
        } = this.props;
        const initialSearchTerm = typeof page === 'string' ? page.split(',').join('|') : undefined;
        return (
            <EventPDFUI
                loading={loading}
                pathname={pathname}
                eventId={eventId}
                hasOtherAttachment={hasOtherAttachment}
                initialSearchTerm={initialSearchTerm}
                eventTitle={eventTitle}
                dateString={dateString}
                company={company}
                pdfUrl={pdfUrl}
                containerRef={this.containerRef}
                setToolbarTitle={setToolbarTitle}
                styles={styles}
                title={title}
                type={type}
            />
        );
    }
}

export const EventPDFContainer = compose(withData(), withUrlContext(['pathname', 'page']))(EventPDF);
